'use strict';
define([
    'angular',
    'modules/copymetrics/analyzer/analyzer.controller',
],function(angular, CopymetricsCtrl){
    var app=angular.module('app.copymetrics.analyzer', []);
    app.controller('CopymetricsCtrl',CopymetricsCtrl);
    return app;
});
